// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function fare_amount_encode(v) {
  return Js_dict.fromArray([
              [
                "currency",
                Decco.stringToJson(v.currency)
              ],
              [
                "minor_amount",
                Decco.intToJson(v.minor_amount)
              ]
            ]);
}

function fare_amount_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var currency = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "currency"), null));
  if (currency.TAG === /* Ok */0) {
    var minor_amount = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "minor_amount"), null));
    if (minor_amount.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                currency: currency._0,
                minor_amount: minor_amount._0
              }
            };
    }
    var e = minor_amount._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".minor_amount" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = currency._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".currency" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function slab_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var slab_km = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "slab_km"), null));
  if (slab_km.TAG === /* Ok */0) {
    var price_per_min = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min"), null));
    if (price_per_min.TAG === /* Ok */0) {
      var price_per_km = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_km"), null));
      if (price_per_km.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  slab_km: slab_km._0,
                  price_per_min: price_per_min._0,
                  price_per_km: price_per_km._0
                }
              };
      }
      var e = price_per_km._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".price_per_km" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = price_per_min._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".price_per_min" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = slab_km._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".slab_km" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function eligibility_config_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var start_time = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_time"), null));
  if (start_time.TAG === /* Ok */0) {
    var end_time = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_time"), null));
    if (end_time.TAG === /* Ok */0) {
      var repeat_on_days = Decco.optionFromJson((function (param) {
              return Decco.listFromJson(Decco.stringFromJson, param);
            }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "repeat_on_days"), null));
      if (repeat_on_days.TAG === /* Ok */0) {
        var pickup_zone_ids = Decco.optionFromJson((function (param) {
                return Decco.listFromJson(Decco.intFromJson, param);
              }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_zone_ids"), null));
        if (pickup_zone_ids.TAG === /* Ok */0) {
          var pickup_cluster_ids = Decco.optionFromJson((function (param) {
                  return Decco.listFromJson(Decco.intFromJson, param);
                }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "pickup_cluster_ids"), null));
          if (pickup_cluster_ids.TAG === /* Ok */0) {
            var drop_zone_ids = Decco.optionFromJson((function (param) {
                    return Decco.listFromJson(Decco.intFromJson, param);
                  }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "drop_zone_ids"), null));
            if (drop_zone_ids.TAG === /* Ok */0) {
              var drop_cluster_ids = Decco.optionFromJson((function (param) {
                      return Decco.listFromJson(Decco.intFromJson, param);
                    }), Belt_Option.getWithDefault(Js_dict.get(dict$1, "drop_cluster_ids"), null));
              if (drop_cluster_ids.TAG === /* Ok */0) {
                return {
                        TAG: /* Ok */0,
                        _0: {
                          start_time: start_time._0,
                          end_time: end_time._0,
                          repeat_on_days: repeat_on_days._0,
                          pickup_zone_ids: pickup_zone_ids._0,
                          pickup_cluster_ids: pickup_cluster_ids._0,
                          drop_zone_ids: drop_zone_ids._0,
                          drop_cluster_ids: drop_cluster_ids._0
                        }
                      };
              }
              var e = drop_cluster_ids._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".drop_cluster_ids" + e.path,
                        message: e.message,
                        value: e.value
                      }
                    };
            }
            var e$1 = drop_zone_ids._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".drop_zone_ids" + e$1.path,
                      message: e$1.message,
                      value: e$1.value
                    }
                  };
          }
          var e$2 = pickup_cluster_ids._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".pickup_cluster_ids" + e$2.path,
                    message: e$2.message,
                    value: e$2.value
                  }
                };
        }
        var e$3 = pickup_zone_ids._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".pickup_zone_ids" + e$3.path,
                  message: e$3.message,
                  value: e$3.value
                }
              };
      }
      var e$4 = repeat_on_days._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".repeat_on_days" + e$4.path,
                message: e$4.message,
                value: e$4.value
              }
            };
    }
    var e$5 = end_time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".end_time" + e$5.path,
              message: e$5.message,
              value: e$5.value
            }
          };
  }
  var e$6 = start_time._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".start_time" + e$6.path,
            message: e$6.message,
            value: e$6.value
          }
        };
}

function free_distance_pricing_delta_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var free_kms_delta = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_kms_delta"), null));
  if (free_kms_delta.TAG === /* Ok */0) {
    var price_per_min_delta = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "price_per_min_delta"), null));
    if (price_per_min_delta.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                free_kms_delta: free_kms_delta._0,
                price_per_min_delta: price_per_min_delta._0
              }
            };
    }
    var e = price_per_min_delta._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".price_per_min_delta" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = free_kms_delta._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".free_kms_delta" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function delta_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var base_fare_delta = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "base_fare_delta"), null));
  if (base_fare_delta.TAG === /* Ok */0) {
    var waiting_rate_per_minute_delta = fare_amount_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "waiting_rate_per_minute_delta"), null));
    if (waiting_rate_per_minute_delta.TAG === /* Ok */0) {
      var free_duration_delta = Decco.intFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_duration_delta"), null));
      if (free_duration_delta.TAG === /* Ok */0) {
        var free_distance_pricing_delta = free_distance_pricing_delta_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "free_distance_pricing_delta"), null));
        if (free_distance_pricing_delta.TAG === /* Ok */0) {
          var distance_time_pricing = Decco.listFromJson(slab_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "distance_time_pricing"), null));
          if (distance_time_pricing.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      base_fare_delta: base_fare_delta._0,
                      waiting_rate_per_minute_delta: waiting_rate_per_minute_delta._0,
                      free_duration_delta: free_duration_delta._0,
                      free_distance_pricing_delta: free_distance_pricing_delta._0,
                      distance_time_pricing: distance_time_pricing._0
                    }
                  };
          }
          var e = distance_time_pricing._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".distance_time_pricing" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = free_distance_pricing_delta._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".free_distance_pricing_delta" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = free_duration_delta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".free_duration_delta" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = waiting_rate_per_minute_delta._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".waiting_rate_per_minute_delta" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = base_fare_delta._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".base_fare_delta" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function approver_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var first_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
  if (first_name.TAG === /* Ok */0) {
    var last_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
    if (last_name.TAG === /* Ok */0) {
      var email = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "email"), null));
      if (email.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  first_name: first_name._0,
                  last_name: last_name._0,
                  email: email._0
                }
              };
      }
      var e = email._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".email" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = last_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_name" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = first_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".first_name" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function status_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var campaign_status = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "campaign_status"), null));
  if (campaign_status.TAG === /* Ok */0) {
    var approval_time = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approval_time"), null));
    if (approval_time.TAG === /* Ok */0) {
      var approver = Decco.optionFromJson(approver_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "approver"), null));
      if (approver.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  campaign_status: campaign_status._0,
                  approval_time: approval_time._0,
                  approver: approver._0
                }
              };
      }
      var e = approver._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".approver" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = approval_time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".approval_time" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = campaign_status._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".campaign_status" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function test_sample_criteria_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var customer_id_buckets = Decco.listFromJson(Decco.intFromJson, Belt_Option.getWithDefault(Js_dict.get(dict._0, "customer_id_buckets"), null));
  if (customer_id_buckets.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              customer_id_buckets: customer_id_buckets._0
            }
          };
  }
  var e = customer_id_buckets._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".customer_id_buckets" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

function modification_detail_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var modification = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "modification"), null));
  if (modification.TAG === /* Ok */0) {
    var delta = Decco.optionFromJson(delta_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "delta"), null));
    if (delta.TAG === /* Ok */0) {
      var test_delta = Decco.optionFromJson(delta_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "test_delta"), null));
      if (test_delta.TAG === /* Ok */0) {
        var control_delta = Decco.optionFromJson(delta_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "control_delta"), null));
        if (control_delta.TAG === /* Ok */0) {
          var test_sample_criteria = Decco.optionFromJson(test_sample_criteria_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "test_sample_criteria"), null));
          if (test_sample_criteria.TAG === /* Ok */0) {
            return {
                    TAG: /* Ok */0,
                    _0: {
                      modification: modification._0,
                      delta: delta._0,
                      test_delta: test_delta._0,
                      control_delta: control_delta._0,
                      test_sample_criteria: test_sample_criteria._0
                    }
                  };
          }
          var e = test_sample_criteria._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".test_sample_criteria" + e.path,
                    message: e.message,
                    value: e.value
                  }
                };
        }
        var e$1 = control_delta._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".control_delta" + e$1.path,
                  message: e$1.message,
                  value: e$1.value
                }
              };
      }
      var e$2 = test_delta._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".test_delta" + e$2.path,
                message: e$2.message,
                value: e$2.value
              }
            };
    }
    var e$3 = delta._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".delta" + e$3.path,
              message: e$3.message,
              value: e$3.value
            }
          };
  }
  var e$4 = modification._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".modification" + e$4.path,
            message: e$4.message,
            value: e$4.value
          }
        };
}

function creator_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var first_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "first_name"), null));
  if (first_name.TAG === /* Ok */0) {
    var last_name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "last_name"), null));
    if (last_name.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                first_name: first_name._0,
                last_name: last_name._0
              }
            };
    }
    var e = last_name._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".last_name" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = first_name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".first_name" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function creation_info_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var creator = creator_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creator"), null));
  if (creator.TAG === /* Ok */0) {
    var creation_time = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creation_time"), null));
    if (creation_time.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                creator: creator._0,
                creation_time: creation_time._0
              }
            };
    }
    var e = creation_time._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".creation_time" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = creator._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".creator" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

function modification_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var name = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "name"), null));
  if (name.TAG === /* Ok */0) {
    var external_id = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "external_id"), null));
    if (external_id.TAG === /* Ok */0) {
      var start_instant = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "start_instant"), null));
      if (start_instant.TAG === /* Ok */0) {
        var end_instant = Decco.optionFromJson(Decco.floatFromJson, Belt_Option.getWithDefault(Js_dict.get(dict$1, "end_instant"), null));
        if (end_instant.TAG === /* Ok */0) {
          var status = status_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "status"), null));
          if (status.TAG === /* Ok */0) {
            var modification = Decco.listFromJson(modification_detail_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "modification"), null));
            if (modification.TAG === /* Ok */0) {
              var eligibility_config = eligibility_config_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "eligibility_config"), null));
              if (eligibility_config.TAG === /* Ok */0) {
                var creation_info = creation_info_decode(Belt_Option.getWithDefault(Js_dict.get(dict$1, "creation_info"), null));
                if (creation_info.TAG === /* Ok */0) {
                  return {
                          TAG: /* Ok */0,
                          _0: {
                            name: name._0,
                            external_id: external_id._0,
                            start_instant: start_instant._0,
                            end_instant: end_instant._0,
                            status: status._0,
                            modification: modification._0,
                            eligibility_config: eligibility_config._0,
                            creation_info: creation_info._0
                          }
                        };
                }
                var e = creation_info._0;
                return {
                        TAG: /* Error */1,
                        _0: {
                          path: ".creation_info" + e.path,
                          message: e.message,
                          value: e.value
                        }
                      };
              }
              var e$1 = eligibility_config._0;
              return {
                      TAG: /* Error */1,
                      _0: {
                        path: ".eligibility_config" + e$1.path,
                        message: e$1.message,
                        value: e$1.value
                      }
                    };
            }
            var e$2 = modification._0;
            return {
                    TAG: /* Error */1,
                    _0: {
                      path: ".modification" + e$2.path,
                      message: e$2.message,
                      value: e$2.value
                    }
                  };
          }
          var e$3 = status._0;
          return {
                  TAG: /* Error */1,
                  _0: {
                    path: ".status" + e$3.path,
                    message: e$3.message,
                    value: e$3.value
                  }
                };
        }
        var e$4 = end_instant._0;
        return {
                TAG: /* Error */1,
                _0: {
                  path: ".end_instant" + e$4.path,
                  message: e$4.message,
                  value: e$4.value
                }
              };
      }
      var e$5 = start_instant._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".start_instant" + e$5.path,
                message: e$5.message,
                value: e$5.value
              }
            };
    }
    var e$6 = external_id._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".external_id" + e$6.path,
              message: e$6.message,
              value: e$6.value
            }
          };
  }
  var e$7 = name._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".name" + e$7.path,
            message: e$7.message,
            value: e$7.value
          }
        };
}

function modification_list_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var modification_campaigns = Decco.listFromJson(modification_decode, Belt_Option.getWithDefault(Js_dict.get(dict._0, "modification_campaigns"), null));
  if (modification_campaigns.TAG === /* Ok */0) {
    return {
            TAG: /* Ok */0,
            _0: {
              modification_campaigns: modification_campaigns._0
            }
          };
  }
  var e = modification_campaigns._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".modification_campaigns" + e.path,
            message: e.message,
            value: e.value
          }
        };
}

export {
  fare_amount_encode ,
  fare_amount_decode ,
  slab_decode ,
  eligibility_config_decode ,
  free_distance_pricing_delta_decode ,
  delta_decode ,
  approver_decode ,
  status_decode ,
  test_sample_criteria_decode ,
  modification_detail_decode ,
  creator_decode ,
  creation_info_decode ,
  modification_decode ,
  modification_list_decode ,
  
}
/* No side effect */
